import React, { useState } from "react";
import "../../Css/GpuManuals.css";
import banner from "../../Assets/background2.JPG";
import Nav from "../../Utils/Nav";
import Footer from "../../Utils/Footer";

const Manuals = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const gettingStart = [
    `To use Nvidia GPU, you require your account on the server`,
    "The administrator provides the account credentials",
    "Once you get your credentials, you have to ssh to the container (use putty or any other ssh client in case of windows)",
    `Eg:`,
    `ssh username@server ip`,
    `Note: the username and server name /IP is provided by the administrator`,
    `You are provided with sudo access to the container so that you can install your required softwares and libraries.`,
  ];

  const steps = [
    {
      title: "Step 1: Install CUDA 12.4",
      command: `wget https://developer.download.nvidia.com/compute/cuda/repos/ubuntu2204/x86_64/cuda-ubuntu2204.pin
sudo mv cuda-ubuntu2204.pin /etc/apt/preferences.d/cuda-repository-pin-600
wget https://developer.download.nvidia.com/compute/cuda/12.4.0/local_installers/cuda-repo-ubuntu2204-12-4-local_12.4.0-550.54.14-1_amd64.deb
sudo dpkg -i cuda-repo-ubuntu2204-12-4-local_12.4.0-550.54.14-1_amd64.deb
sudo cp /var/cuda-repo-ubuntu2204-12-4-local/cuda-*-keyring.gpg /usr/share/keyrings/
sudo apt-get update`,
    },
    {
      title: "Step 2: Enable Ubuntu 20.04 (Focal) Repositories",
      command: `echo "deb http://archive.ubuntu.com/ubuntu focal main universe" | sudo tee /etc/apt/sources.list.d/focal.list
sudo apt update`,
    },
    {
      title: "Step 3: Install Dependencies",
      command: `sudo apt install -y libtinfo5`,
    },
    {
      title: "Step 4: Install CUDA Toolkit",
      command: `sudo apt-get -y install cuda-toolkit-12-4`,
    },
    {
      title: "Step 5: Verify Installation",
      command: `echo $PATH | grep cuda
ls /usr/local/`,
    },
    {
      title: "Step 6: Set Environment Variables",
      command: `echo 'export PATH=/usr/local/cuda-12.4/bin:$PATH' >> ~/.bashrc
echo 'export LD_LIBRARY_PATH=/usr/local/cuda-12.4/lib64:$LD_LIBRARY_PATH' >> ~/.bashrc
source ~/.bashrc
nvcc --version`,
    },
    {
      title: "Step 7: Set Up Python Virtual Environment & Install PyTorch",
      command: `sudo apt install -y python3.12-venv
python3 -m venv venv
source venv/bin/activate
pip install torch torchvision torchaudio --index-url https://download.pytorch.org/whl/cu124
deactivate`,
    },
    {
      title: "Step 8: Install PyTorch Again (Optional if needed again)",
      command: `source venv/bin/activate
pip install torch torchvision torchaudio --index-url https://download.pytorch.org/whl/cu124
deactivate`,
    },
    {
      title: "Step 9: Create and Run Python Test Script",
      command: `sudo nano test.py`,
      code: `import torch
print(f'PyTorch version: {torch.__version__}')
print(f'CUDA Available: {torch.cuda.is_available()}')
print(f'Number of GPUs: {torch.cuda.device_count()}')
if torch.cuda.is_available():
    print(f'Current Device: {torch.cuda.current_device()}')
    print(f'Device Name: {torch.cuda.get_device_name(torch.cuda.current_device())}')
print(torch.backends.cudnn.enabled)
print(torch.version.cuda)" > test.py`,
      postCommand: `source venv/bin/activate
python3 test.py
deactivate`,
    },
    {
      title: "Step 10: Install Conda & CUDA Toolkit via Conda (If Needed)",
      command: `wget https://repo.anaconda.com/archive/Anaconda3-2024.10-1-Linux-x86_64.sh
bash Anaconda3-2024.10-1-Linux-x86_64.sh -b -p $HOME/anaconda3
export PATH="$HOME/anaconda3/bin:$PATH"
source ~/.bashrc

conda install -y conda-forge::cudatoolkit-dev
conda create -y -n envname python=3.10
conda activate envname
pip install torch torchaudio torchvision
echo "CUDA setup complete!"`,
    },
    {
      title: "Do's & Don'ts",
      content: `Never Ever run "sudo reboot" "sudo apt upgrade" and "sudo apt install -y nvidia-utils-X" and "apt install -y nvidia-toolkit-X" , Any Kind of Desktop Environment or uninstalling/installing the NVIDIA Drivers in containers.`,
    },
  ];

  return (
    <>
      <style>
        {`
          /* Accordion Button */
          .accordion {
            width: 100%;
            text-align: left;
            padding: 15px;
            font-size: 16px;
            border: none;
            cursor: pointer;
            background: #004080;
            color: white;
            margin-top: 5px;
            border-radius: 5px;
            transition: background 0.3s ease;
          }

          .accordion:hover {
            background: #003060;
          }

          /* Accordion Panel */
          .panel {
            display: block;
            padding: 15px;
            background: #f9fbff;
            border: 1px solid #ddd;
            border-radius: 5px;
            margin-top: 5px;
            animation: fadeIn 0.3s ease;
          }

          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(-5px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .manual-section {
            background: white;
            border-radius: 8px;
            padding: 10px;
            width: 100%;
            margin-bottom: 10px;
          }

          .step {
            background: #f0f4ff;
            padding: 10px;
            margin: 10px 0;
            border-left: 4px solid #004080;
          }

          .step ul {
            margin-left: 15px;
            padding-left: 15px;
          }

          .gpu-code-block {
            background: #f5f5f5;
            border: 1px solid #ddd;
            border-radius: 4px;
            padding: 10px;
            margin: 10px 0;
            overflow-x: auto;
          }

          .gpu-code-block pre {
            margin: 0;
            font-size: 12px;
            font-family: 'Courier New', monospace;
          }

          .highlight {
            background: #eef3ff;
            padding: 15px;
            border-left: 5px solid #004080;
            margin-top: 10px;
          }

          .manual-section h2 {
            color: #004080;
            margin-top: 0;
          }

          .manual-section h3 {
            color: #004080;
            margin-top: 20px;
            margin-bottom: 10px;
          }

          .manual-section h4 {
            color: #004080;
            margin-top: 15px;
            margin-bottom: 10px;
          }

          .manual-section ol,
          .manual-section ul {
            margin-left: 20px;
            padding-left: 0;
          }

          .manual-section a {
            color: #004080;
            text-decoration: none;
            font-weight: bold;
          }

          .manual-section a:hover {
            text-decoration: underline;
          }

          .gpu-text-block {
            line-height: 1.6;
            color: #333;
          }

          .start-list {
            color: #004080;
            margin-top: 20px;
            margin-bottom: 10px;
          }

          .start-steps,
          .start-sub-steps {
            margin-bottom: 8px;
            line-height: 1.6;
          }

          .start-sub-steps {
            margin-left: 20px;
          }

          .gpu-step {
            margin-bottom: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid #eee;
          }

          .gpu-guide-list {
            list-style-type: decimal;
            padding-left: 20px;
          }
        `}
      </style>
      <Nav />
      <div className="main-container">
        <div className="banner">
          <img className="background" src={banner} alt="" />
          <h1 className="main-heading-title">Manuals</h1>
        </div>

        <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "25px" }}>
          {/* GPU Setup Instructions Accordion */}
          <div className="manual-section">
            <button className="accordion" onClick={() => toggleAccordion(0)}>
              {openIndex === 0 ? "− GPU Setup Instructions" : "+ GPU Setup Instructions"}
            </button>

            {openIndex === 0 && (
              <div className="panel">
                <h3 className="start-list">Getting Started</h3>
                <ol>
                  {gettingStart.map((step, index) => {
                    const subStepIndices = [3, 4, 5];
                    return subStepIndices.includes(index) ? (
                      <li key={index} className="start-sub-steps">
                        {step}
                      </li>
                    ) : (
                      <li key={index} className="start-steps">
                        {step}
                      </li>
                    );
                  })}
                </ol>

                <h3 className="start-list">GPU Container CUDA and Pytorch Installation and Do's & Don'ts</h3>
                <p style={{ color: "#004080", textDecoration: "underline", fontWeight: 700 }}>
                  Installation and Environment Creation
                </p>

                <ol className="gpu-guide-list">
                  {steps.map((step, index) => (
                    <li key={index} className="gpu-step">
                      <h4>{step.title}</h4>

                      {step.content &&
                        (step.title !== "Do's & Don'ts" ? (
                          <p className="gpu-text-block">{step.content}</p>
                        ) : (
                          <p className="highlight">{step.content}</p>
                        ))}

                      {step.command && (
                        <div className="gpu-code-block">
                          <pre>{step.command}</pre>
                        </div>
                      )}

                      {step.code && (
                        <div className="gpu-code-block">
                          <pre>{step.code}</pre>
                        </div>
                      )}

                      {step.postCommand && (
                        <div className="gpu-code-block">
                          <pre>{step.postCommand}</pre>
                        </div>
                      )}
                    </li>
                  ))}
                </ol>
              </div>
            )}
          </div>

          {/* SLURM Environment Setup Accordion */}
          <div className="manual-section">
            <button className="accordion" onClick={() => toggleAccordion(1)}>
              {openIndex === 1 ? "−  SLURM - Environment Setup" : "+  SLURM - Environment Setup"}
            </button>

            {openIndex === 1 && (
              <div className="panel">
                <h3>How to Access the Cluster:</h3>
                <ul>
                  <li>Login using a terminal or SSH client</li>
                  <li><strong>IP Address:</strong> 172.30.10.8</li>
                  <li><strong>Hostname:</strong> him2.iitrpr.ac.in</li>
                  <li><strong>Username:</strong> (provided by administrator)</li>
                  <li><strong>Password:</strong> (provided by administrator)</li>
                </ul>
                <div className="step">
                  <strong>Example (Linux/macOS/Windows):</strong>
                  <div className="gpu-code-block">
                    <pre>ssh username@172.30.10.8</pre>
                  </div>
                </div>

                <h3>Initial Setup:</h3>
                <p>After logging in:</p>
                <ol>
                  <li>Upload your dataset and project files to your home directory</li>
                  <li>Install Anaconda or Miniconda (if not already installed)</li>
                  <li>Create a virtual environment</li>
                  <li>Install required libraries</li>
                  <li>Submit jobs using SLURM</li>
                </ol>

                <h3>Environment Setup Guide</h3>

                <div className="step">
                  <strong>Step 1: Install Anaconda</strong>
                  <ul>
                    <li>Download from: <a href="https://www.anaconda.com/download" target="_blank" rel="noreferrer">https://www.anaconda.com/download</a></li>
                    <li>Install based on your OS</li>
                  </ul>
                  <p><strong>Linux:</strong></p>
                  <div className="gpu-code-block">
                    <pre>bash Anaconda3-2024.10-1-Linux-x86_64.sh
conda --version</pre>
                  </div>
                </div>

                <div className="step">
                  <strong>Step 2: Create a Conda Environment</strong>
                  <div className="gpu-code-block">
                    <pre>conda create -n myenv python=3.10
conda activate myenv
python --version</pre>
                  </div>
                </div>

                <div className="step">
                  <strong>Step 3: Check GPU and CUDA Version</strong>
                  <div className="gpu-code-block">
                    <pre>nvidia-smi</pre>
                  </div>
                </div>

                <div className="step">
                  <strong>Step 4: Install PyTorch (CUDA compatible)</strong>
                  <div className="gpu-code-block">
                    <pre>pip install torch torchvision torchaudio --index-url https://download.pytorch.org/whl/cu121</pre>
                  </div>
                </div>

                <h3>Submitting Jobs with SLURM</h3>
                <p><strong>Example job script (job.sh):</strong></p>
                <div className="gpu-code-block">
                  <pre>{`#!/bin/bash
#SBATCH --job-name=python-job
#SBATCH --partition=debug
#SBATCH --gres=gpu:1
#SBATCH --cpus-per-task=12
#SBATCH --mem=40G
#SBATCH --time=0-47:00:00
#SBATCH --output=/raid/scratch/%u/slurm-%j.out
#SBATCH --error=/raid/scratch/%u/slurm-%j.err

source /raid/home/username/miniconda3/etc/profile.d/conda.sh
cd /path/to/your/project || exit 1
conda activate myenv
python file_name.py`}</pre>
                </div>

                <p><strong>Submit job:</strong></p>
                <div className="gpu-code-block">
                  <pre>sbatch job.sh</pre>
                </div>

                <h3>Useful SLURM Commands:</h3>
                <ul>
                  <li><strong>Check jobs:</strong><div className="gpu-code-block"><pre>squeue</pre></div></li>
                  <li><strong>Cancel job:</strong><div className="gpu-code-block"><pre>scancel &lt;job_id&gt;</pre></div></li>
                  <li><strong>Job details:</strong><div className="gpu-code-block"><pre>scontrol show job &lt;job_id&gt;</pre></div></li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Manuals;
